var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5833333333333334,0,0,0.5833333333333334,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,5.41a1,1,0,0,0-1-1H11.55a.47.47,0,0,1-.32-.12L6.54.4A1.7,1.7,0,0,0,4.29.74l-4,4A1.38,1.38,0,0,0,0,5.52V8.91a1.5,1.5,0,0,0,1.5,1.5H2a.5.5,0,0,1,.5.5v8.48a.5.5,0,0,1-.5.5H1a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1v-9a1,1,0,0,0-1-1H20a1,1,0,0,0-1,1v2.5a.5.5,0,0,1-.5.5h-.75a.5.5,0,0,1-.5-.5V14.14a1,1,0,0,0-2,0v2.25a.5.5,0,0,1-.5.5h-.5a.5.5,0,0,1-.5-.5V14.14a1,1,0,0,0-2,0v2.25a.5.5,0,0,1-.5.5H11a1,1,0,0,0-1,1v1.5a.5.5,0,0,1-.5.5H9a.5.5,0,0,1-.5-.5V10.91a.5.5,0,0,1,.5-.5h6.5a.5.5,0,0,1,.5.5v.49a1,1,0,0,0,2,0ZM2,6.91a.5.5,0,0,1,.5-.5h13a.49.49,0,0,1,.5.49v1a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5ZM5.3,2.56a.49.49,0,0,1,.67,0l1.2,1a.52.52,0,0,1,.15.56.5.5,0,0,1-.47.33H4.65a.5.5,0,0,1-.35-.86ZM5,19.89a.5.5,0,0,1-.5-.5V10.91a.5.5,0,0,1,.5-.5H6a.5.5,0,0,1,.5.5v8.48a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "current"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.f6270ed3624cbc5683a7ff465e703ec8.svg";
export { ForwardRef as ReactComponent };